import { AppError } from 'app/common/app-error';

export class BadInput extends AppError {}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/common/bad-input.ts